export const onCreateTask = /* GraphQL */ `
  subscription onCreateTask($taskListUnitId: ModelSubscriptionIDInput!) {
  onCreateTask(taskListUnitId: $taskListUnitId) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const onCreateTaskListUnit = /* GraphQL */ `
  subscription onCreateTaskListUnit($workspaceId: ModelSubscriptionIDInput!) {
  onCreateTaskListUnit(workspaceId: $workspaceId) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const onCreateTaskReport = /* GraphQL */ `
  subscription onCreateTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
  onCreateTaskReport(taskListUnitId: $taskListUnitId) {
      comment
      commentImages
      completedAt
      completedBy
      createdAt
      createdBy
      id
      images
      logicalDayStart
      status
      taskId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const onDeleteTask = /* GraphQL */ `
  subscription onDeleteTask($taskListUnitId: ModelSubscriptionIDInput!) {
  onDeleteTask(taskListUnitId: $taskListUnitId) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const onDeleteTaskListUnit = /* GraphQL */ `
  subscription onDeleteTaskListUnit($workspaceId: ModelSubscriptionIDInput!) {
  onDeleteTaskListUnit(workspaceId: $workspaceId) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const onDeleteTaskReport = /* GraphQL */ `
  subscription onDeleteTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
  onDeleteTaskReport(taskListUnitId: $taskListUnitId) {
      comment
      commentImages
      completedAt
      completedBy
      createdAt
      createdBy
      id
      images
      logicalDayStart
      status
      taskId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const onUpdateTask = /* GraphQL */ `
  subscription onUpdateTask($taskListUnitId: ModelSubscriptionIDInput!) {
  onUpdateTask(taskListUnitId: $taskListUnitId) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const onUpdateTaskListUnit = /* GraphQL */ `
  subscription onUpdateTaskListUnit($workspaceId: ModelSubscriptionIDInput!) {
  onUpdateTaskListUnit(workspaceId: $workspaceId) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const onUpdateTaskReport = /* GraphQL */ `
  subscription onUpdateTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
  onUpdateTaskReport(taskListUnitId: $taskListUnitId) {
      comment
      commentImages
      completedAt
      completedBy
      createdAt
      createdBy
      id
      images
      logicalDayStart
      status
      taskId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;
